import { IconCopy } from '@src/assets/icon-copy';
import type { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import { useEffect, useState } from 'react';
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
} from 'react-share';
import { twMerge } from 'tailwind-merge';

interface Props
  extends PropsWithClassProps<'socialsWrapper' | 'copyButton' | 'copyText' | 'copyIconWrapper' | 'copyIcon' | 'icon'> {}

export function SocialShare({ classProps }: Props) {
  const [url, setUrl] = useState('');
  useEffect(() => {
    setUrl(window.location.href);
  }, []);
  const fill = 'rgba(24,24,24,0.70)';

  return (
    <div className={twMerge('px-4', classProps?.root)}>
      <div
        className={twMerge(
          'flex shrink-0 items-center justify-between border-gray-500 border-b py-6',
          classProps?.socialsWrapper,
        )}
      >
        <WhatsappShareButton url={url}>
          <WhatsappIcon
            round={true}
            className={twMerge('button-icon !size-12 p-2', classProps?.icon)}
            iconFillColor="currentColor"
            bgStyle={{ fill }}
          />
        </WhatsappShareButton>
        <FacebookShareButton url={url}>
          <FacebookIcon
            round={true}
            className={twMerge('button-icon !size-12 p-1', classProps?.icon)}
            iconFillColor="currentColor"
            bgStyle={{ fill }}
          />
        </FacebookShareButton>
        <TwitterShareButton url={url}>
          <XIcon
            round={true}
            className={twMerge('button-icon !size-12 p-1', classProps?.icon)}
            iconFillColor="currentColor"
            bgStyle={{ fill }}
          />
        </TwitterShareButton>
        <EmailShareButton url={url}>
          <EmailIcon
            round={true}
            className={twMerge('button-icon !size-12 p-0.5', classProps?.icon)}
            iconFillColor="currentColor"
            bgStyle={{ fill }}
          />
        </EmailShareButton>
      </div>
      <button
        type="button"
        onClick={() => navigator.clipboard.writeText(url)}
        className={twMerge('group flex shrink-0 items-center gap-4 py-6', classProps?.copyButton)}
      >
        <div className={twMerge('button-icon !size-12', classProps?.copyIconWrapper)}>
          <IconCopy classProps={{ root: twMerge('', classProps?.copyIcon) }} />
        </div>
        <span className={twMerge('text-xl', classProps?.copyText)}>Link kopieren</span>
      </button>
    </div>
  );
}
